import { render, staticRenderFns } from "./PlayTable.vue?vue&type=template&id=21ebe1a2&scoped=true"
import script from "./PlayTable.vue?vue&type=script&lang=js"
export * from "./PlayTable.vue?vue&type=script&lang=js"
import style0 from "./PlayTable.vue?vue&type=style&index=0&id=21ebe1a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ebe1a2",
  null
  
)

export default component.exports